import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { ContractFromApi, ContractTableRow } from '../types/contracts.types';
import { effectiveDateFormat } from './contractAIQHelper';

export const formatContractsData = (
  item: ContractFromApi,
  uploadedDocuments: { document_id: string }[],
): ContractTableRow => ({
  contract_id: item._id || '',
  name: item.health_care_partner,
  type: item.service_agreement_name,
  totalFiles: item.total_files,
  effectiveDate: effectiveDateFormat(item.effective_date),
  subrows:
    item.documents?.map((doc, index) => ({
      id: index,
      document: doc.document_name,
      documentType: doc.document_type,
      totalFiles: '-',
      effectiveDate: effectiveDateFormat(doc.document_effective_date),
      background: uploadedDocuments.some(
        (uploadDoc) => uploadDoc.document_id === doc._id,
      )
        ? '#fff9cc'
        : patientAccessTheme.palette.grey[100],
    })) ?? [],
});
